module.exports = __webpack_public_path__ + "static/2015-360258b267b1e770c568734520d5e698.webp";